// userActions.js — thunks → userServices (DealCouponz-style)
import * as userTypes from "../types/userTypes";
import * as couponLikeTypes from "../types/couponLikeTypes";
import * as couponCommentTypes from "../types/couponCommentTypes";
import * as couponVoteTypes from "../types/couponVoteTypes";
import * as couponViewTypes from "../types/couponViewTypes";
import * as userServices from "../../services/userServices";
import * as couponLikeServices from "../../services/couponLikeServices";

export const refreshUserPortfolio = () => async (dispatch) => {
  dispatch({ type: userTypes.USER_PORTFOLIO_REQUEST });
  dispatch({ type: couponLikeTypes.COUPON_LIKED_LIST_REQUEST });
  try {
    const [likedCoupons, savings, myComments] = await Promise.all([
      couponLikeServices.listLikedCoupons(),
      userServices.listSavings(),
      userServices.listMyComments(),
    ]);
    dispatch({
      type: userTypes.USER_PORTFOLIO_SUCCESS,
      payload: { savings, myComments },
    });
    dispatch({
      type: couponLikeTypes.COUPON_LIKED_LIST_SUCCESS,
      payload: likedCoupons,
    });
  } catch (e) {
    const msg =
      e?.response?.data?.message || e?.message || "Could not load account data";
    dispatch({ type: userTypes.USER_PORTFOLIO_FAILURE, payload: msg });
    dispatch({ type: couponLikeTypes.COUPON_LIKED_LIST_FAILURE, payload: msg });
  }
};

export const clearUserPortfolio = () => (dispatch) => {
  dispatch({ type: userTypes.USER_CLEAR });
  dispatch({ type: couponLikeTypes.COUPON_LIKE_CLEAR });
  dispatch({ type: couponCommentTypes.COUPON_COMMENTS_CLEAR });
  dispatch({ type: couponVoteTypes.COUPON_VOTE_CLEAR });
  dispatch({ type: couponViewTypes.COUPON_VIEW_CLEAR });
};
